import { render, staticRenderFns } from "./ListPendingFirstReports.vue?vue&type=template&id=4a15bfe2&lang=pug&"
import script from "./ListPendingFirstReports.vue?vue&type=script&lang=ts&"
export * from "./ListPendingFirstReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports